import { useGetOne } from "ra-core";
import { useMemo } from "react";
import { mergeGavionConfig, type GavionConfig } from "../domain/config";

/** Reads configuration.config.gavion (row id 1) and merges it with the defaults. */
export function useGavionConfig(): {
  config: GavionConfig;
  isPending: boolean;
} {
  const { data, isPending } = useGetOne<{
    id: number;
    config?: { gavion?: unknown };
  }>("configuration", { id: 1 }, { staleTime: 60_000 });
  const config = useMemo(() => mergeGavionConfig(data?.config?.gavion), [data]);
  return { config, isPending };
}
